let Navigation = {
    init: () => {
        handleNavClick();
    }
};

const handleNavClick = () => {
    let $navSettings = $('.nav-settings'),
        $navPersonMenu = $('.nav-person-menu'),
        $navTopMenuMobileButton = $('.nav-mobile-top-menu-expand'),
        $navTopDropdownMenuMobile = $('.nav-mobile-top-menu'),
        //OB elements
        $navMobileOb = $('.nav-mobile-onboarding'),
        $navButtonDots = $('.nav-button-kebab');

    $navSettings.click(function() {
        $navPersonMenu.toggleClass('visible');
        $(this).toggleClass('open');
    });

    $navTopMenuMobileButton.click(function() {
        $navTopDropdownMenuMobile.toggleClass('visible');
        $(this).toggleClass('open');
    });

    $(document).on('click', function(e) {
        if (!$(e.target).closest($navSettings).length && !$(e.target).closest($navPersonMenu).length) {
            $navPersonMenu.removeClass('visible');
            $navSettings.removeClass('open');
        }
    });

    $(document).on('click', function(e) {
        if (!$(e.target).closest($navTopMenuMobileButton).length && !$(e.target).closest($navTopDropdownMenuMobile).length) {
            $navTopDropdownMenuMobile.removeClass('visible');
            $navTopMenuMobileButton.removeClass('open');
        }
    });

    $('button[data-menu-target]').click(function() {
        const target = $(this).data('menuTarget');
        $('body').addClass('nav-mobile-open');
        $('#' + target).addClass('active');
        $('#' + target + ' .icon-close').on('click', function() {
            $('#' + target).removeClass('active');
            $('body').removeClass('nav-mobile-open');
        });
    });


    $navButtonDots.click(() => $navMobileOb.toggleClass('sidebar-active'));
}

export default Navigation;
